module.exports = __webpack_public_path__ + "static/media/search.7772f6f9.svg";